import { getCrmApiOrigin } from '@/config/api-origin';
import { API_ROUTES } from '@/config/api-routes';
function jsonBlob(value) {
    return new Blob([JSON.stringify(value)], { type: 'application/json' });
}
export function buildOfferFormData(offer, quotationFile) {
    const fd = new FormData();
    fd.append('offer', jsonBlob(offer));
    if (quotationFile) {
        fd.append('quotationFile', quotationFile, quotationFile.name);
    }
    return fd;
}
export function buildInvoiceFormData(invoiceFile) {
    const fd = new FormData();
    fd.append('invoiceFile', invoiceFile, invoiceFile.name);
    return fd;
}
export function buildFinalApprovalFormData(approval, ticketFile) {
    const fd = new FormData();
    fd.append('approval', jsonBlob({ approved: true, ...approval }));
    fd.append('ticketFile', ticketFile, ticketFile.name);
    return fd;
}
export function buildRescheduleFormData(reschedule, invoiceFile) {
    const fd = new FormData();
    fd.append('reschedule', jsonBlob(reschedule));
    if (invoiceFile) {
        fd.append('invoiceFile', invoiceFile, invoiceFile.name);
    }
    return fd;
}
export function airplaneTicketFileDownloadUrl(id, fileType) {
    const origin = getCrmApiOrigin();
    const path = API_ROUTES.airplaneTickets.file(id, fileType);
    return origin ? `${origin}${path}` : path;
}
export function readDownloadFilename(response, fallback) {
    const disposition = response.headers['content-disposition'];
    if (disposition) {
        const match = /filename\*?=(?:UTF-8'')?"?([^";\n]+)"?/i.exec(disposition);
        if (match?.[1])
            return decodeURIComponent(match[1].trim());
    }
    return fallback;
}
